import { render, staticRenderFns } from "./knowledge-base-list.vue?vue&type=template&id=f8689db2&lang=pug&"
import script from "./knowledge-base-list.vue?vue&type=script&lang=js&"
export * from "./knowledge-base-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports